import fetchJsonp from 'fetch-jsonp';

// TODO: 拆出去
import { WECHAT_ENV } from '../config';

// 早晚报+资讯+经理小站详情页面是否配置了产品
export const getISCarryProduct = () => {
  const url = location.href;
  const needReportPage =
    url.indexOf('newsPaperDetail') > -1 ||
    url.indexOf('fundWinner/eveningPaper') > -1 ||
    url.indexOf('articleDetail') > -1 ||
    url.indexOf('managerStation') > -1;

  let isCarryProduct: any = '';
  if (needReportPage) {
    isCarryProduct = 0;
    if (sessionStorage.getItem('isCarryProduct') === '1' || sessionStorage.getItem('isCarryProductByInvite') === '1') {
      isCarryProduct = 1;
    }
  }
  return isCarryProduct;
};

// 获取cookie
export function getCookie(name: string): string {
  const strCookie = document.cookie;
  const arrCookie = strCookie.split('; ');
  // eslint-disable-next-line @typescript-eslint/prefer-for-of
  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=');
    if (arr[0] === name) {
      return arr[1];
    }
  }
  return '';
}

// time秒 默认30天
export function setCookie(name: string, value: string, time: number = 30 * 24 * 3600): void {
  const exp = new Date();
  exp.setTime(exp.getTime() + time * 1000);
  document.cookie = name + '=' + value + ';expires=' + exp.toUTCString() + ';path=/';
}

// 清除cookie
export function clearCookieByKey(name: string): void {
  setCookie(name, '', -1);
}

export const getCookieList = () => {
  if (!document.cookie || !navigator.cookieEnabled) {
    return [];
  }

  const list = [];
  const items = document.cookie.split(';');
  for (let i = 0; i < items.length; i++) {
    const item = items[i].split('=');
    let name = item.shift()?.replace(/^ /, '') || '';
    let value = item.join('=');
    try {
      name = decodeURIComponent(name);
      value = decodeURIComponent(value);
    } catch (e) {
      // do not print external input directly to prevent forgery (issue #345)
      // console.log(e, name, value);
    }
    list.push({
      name: name,
      value: value,
    });
  }
  return list;
};

export const clearCookieList = () => {
  if (!document.cookie || !navigator.cookieEnabled) {
    return;
  }
  const hostname = window.location.hostname;
  const list = getCookieList();
  for (let i = 0; i < list.length; i++) {
    const name = list[i].name;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
    document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/;domain=.${hostname
      .split('.')
      .slice(-2)
      .join('.')}`;
  }
};

// 获取sessionStorage
export function getSession(name: string): string | null {
  return sessionStorage.getItem(name);
}

// 设置sessionStorage
export function setSession(name: string, value: any): void {
  sessionStorage.setItem(name, value);
}

//  删除sessionStorage
export function delSession(name: string): void {
  sessionStorage.removeItem(name);
}

// 获取localStorage
export function getLocalStorage(name: string): string | null {
  return localStorage.getItem(name);
}

// 设置localStorage
export function setLocalStorage(name: string, value: any): void {
  localStorage.setItem(name, value);
}

// 删除localStorage
export function delLocalStorage(name: string): void {
  localStorage.removeItem(name);
}

export const clearLocalStorageList = () => {
  if (window.localStorage) {
    try {
      localStorage.clear();
    } catch (e) {
      alert('localStorage.clear() fail.');
    }
  }
};

export const clearSessionStorageList = () => {
  if (window.sessionStorage) {
    try {
      sessionStorage.clear();
    } catch (e) {
      alert('sessionStorage.clear() fail.');
    }
  }
};

// 创建首字母
export const createWord = (name: string) => {
  const Regexp = new RegExp('^[\u4E00-\u9FA5A-Za-z0-9]+$', '');
  if (!name || !name.length) {
    // 客户被删除 或 没有姓名
    return '#';
  } else if (!Regexp.test(name.charAt(0))) {
    // 非法字符（即非汉字、字母和数字）
    return '$$';
  } else {
    return name.charAt(0);
  }
};

// 创建头像
export const createAvator = (name: string) => {
  if (!name || !name.length) {
    return '#91D294';
  }

  const isEng = new RegExp('[a-zA-Z]');
  const isCN = new RegExp('[\u4e00-\u9fa5]');
  const firstLetter = name.charAt(0);
  if (isEng.test(firstLetter)) {
    return '#80BAF7';
  } else if (isCN.test(firstLetter)) {
    return '#81DBC7';
  }

  return '#91D294';
};

// 判断IE
export const isIE = () => {
  if (!!window.ActiveXObject || 'ActiveXObject' in window) {
    return true;
  } else {
    return false;
  }
};

// 判断IE11
export const isIE11 = () => {
  if (/Trident\/7\./.test(navigator.userAgent)) {
    return true;
  } else {
    return false;
  }
};

// 判断当前是微信环境还是企业微信环境
export const getEnv = () => {
  const ua = window.navigator.userAgent.toLowerCase();
  // eslint-disable-next-line
  if (Boolean(ua.match(/MicroMessenger/i)) && Boolean(ua.match(/wxwork/i))) {
    // 企业微信
    // console.log('企业微信环境-1')
    return WECHAT_ENV.qyWechat;
    // eslint-disable-next-line
  } else if (Boolean(ua.match(/micromessenger/i))) {
    // 微信
    // console.log('微信环境-2')
    return WECHAT_ENV.wechat;
  }
};

// 判断企业微信pc端
export const getEnvPC = () => {
  const ua = window.navigator.userAgent;
  return ua.search(/WindowsWechat/i) !== -1 || (ua.search(/Mac OS/i) !== -1 && ua.search(/WeChat/i) !== -1);
};

// 判断是pc端还是移动端
export const isPC = !/Android|webOS|iPhone|iPod|BlackBerry|SymbianOS|Windows Phone/i.test(navigator.userAgent);

export const isIos = !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);

export const isAndroid = navigator.userAgent.indexOf('Android') > -1 || navigator.userAgent.indexOf('Adr') > -1;

// 微信关闭浏览器
export const closeWindow = () => {
  setTimeout(() => {
    if (typeof WeixinJSBridge === 'undefined') {
      // 这个可以关闭安卓系统的手机
      document.addEventListener(
        'WeixinJSBridgeReady',
        () => {
          WeixinJSBridge.call('closeWindow');
        },
        false
      );
    } else {
      // 这个可以关闭ios系统的手机
      WeixinJSBridge.call('closeWindow');
    }
  }, 0);
};

// 跳转到sass系统，传路由路径 + 路径参数
export const toSass = (path: string, queryStr?: string) => {
  const host = import.meta.env.VITE_CAI_ZHI_WEBAPP_HOST as string;
  const newUrl = `${host}${path}?${queryStr || ''}`;
  return newUrl;
};

// 基金数值转换保留小数位 - 不精确的四舍五入 -银行家算法
export const changeFundNumber = (num: any, length = 2, hasPercent = true) => {
  const type = typeof num === 'number' || typeof num === 'string';
  return type && num + '' ? `${(num - 0).toFixed(length)}${hasPercent ? '%' : ''}` : '--';
};

// 数值颜色class名  up  红  down  绿  grey  灰
export const getNumberClassName = (num: any) => {
  const type = typeof num === 'number' || typeof num === 'string';
  if (type && num + '') {
    return num - 0 === 0 ? 'grey' : num - 0 > 0 ? 'fund-up' : 'fund-down';
  } else {
    return 'grey';
  }
};

export const debounce = (fn: { (): void; apply?: any }, delay = 500) => {
  let timer: NodeJS.Timeout | null = null;
  return function () {
    if (timer) {
      clearTimeout(timer);
    }
    timer = setTimeout(() => {
      fn.apply(this, arguments);
      timer = null;
    }, delay);
  };
};

// 防抖函数 立即执行
export function debounceQuick(fn: { (): void; apply?: any }, wait = 500, immediate = true) {
  let timer: NodeJS.Timeout | null, context: null, args: any[] | null;

  const later = () =>
    setTimeout(() => {
      timer = null;
      if (!immediate) {
        fn.apply(context, args);
        context = args = null;
      }
    }, wait);

  // 这里返回的函数是每次实际调用的函数
  return function (...params: any) {
    if (!timer) {
      timer = later();
      if (immediate) {
        fn.apply(this, params);
      } else {
        context = this;
        args = params;
      }
    } else {
      clearTimeout(timer);
      timer = later();
    }
  };
}

/**
 *节流函数
 *
 * @param {Function } fn 执行函数
 * @param {number-毫秒} delay 节流时间
 */
export function throttle(fun: Function, delay: number) {
  let last: number, deferTimer: number;
  return function (args: any) {
    const that: any = this;
    const _args = arguments;
    const now = +new Date();
    if (last && now < last + delay) {
      clearTimeout(deferTimer);
      deferTimer = window.setTimeout(function () {
        last = now;
        fun.apply(that, _args);
      }, delay);
    } else {
      last = now;
      fun.apply(that, _args);
    }
  };
}

// 封装一个jsonp请求的方法
export const requestJSONP = (url: string, params = {} as any) => {
  try {
    if (Object.keys(params).length > 0) {
      let paramsString: any = [];
      for (const key in params) {
        paramsString.push(`${key}=${params[key]}`);
      }
      paramsString = paramsString.join('&');
      url = `${url}?${paramsString}`;
    }
    return new Promise((resolve, reject) => {
      fetchJsonp(url)
        .then(function (response) {
          return response.json();
        })
        .then((res) => {
          if (res.status === 0) {
            resolve(res);
          } else {
            reject(new Error(res.message));
          }
        })
        .catch(function (ex) {
          reject(new Error(ex));
        });
    });
  } catch (error) {
    console.log('requestJSONP error', error);
  }
};

//  对员工姓名进行截短
export const sliceName = (name = '', len = 6) => {
  if (name.length > len) {
    return name.slice(0, len) + '...';
  }
  return name;
};

/**
 * 解决ios回退不刷新的问题
 * @param callback 回调函数
 */
export const iosBackReload = (callback?: () => void) => {
  const browserRule = /^.*((iPhone)|(iPad)|(Safari))+.*$/;
  if (browserRule.test(navigator.userAgent)) {
    window.onpageshow = function (event) {
      if (event.persisted || (window.performance && window.performance.navigation.type == 2)) {
        //页面是从缓存中获取的数据||是通过浏览器后退来到该页面
        if (callback) {
          callback();
        } else {
          window.location.reload();
        }
      }
    };
  }
};

// 返回角度
export function GetSlideAngle(dx: number, dy: number) {
  return (Math.atan2(dy, dx) * 180) / Math.PI;
}

// 根据起点和终点返回方向 1：向上，2：向下，3：向左，4：向右,0：未滑动
export function GetSlideDirection(startX: number, startY: number, endX: number, endY: number) {
  const dy = startY - endY;
  const dx = endX - startX;
  let result = 0;

  // 如果滑动距离太短
  if (Math.abs(dx) < 2 && Math.abs(dy) < 2) {
    return result;
  }

  const angle = GetSlideAngle(dx, dy);
  if (angle >= 0 && angle < 180) {
    result = 1;
  } else if (angle >= -180 && angle < 0) {
    result = 2;
  }

  return result;
}

// 深拷贝
export const deepCopyObj = (obj: { [x: string]: any; hasOwnProperty: (arg0: string) => any }) => {
  // 只拷贝对象
  if (typeof obj !== 'object') return;
  // 根据obj的类型判断是新建一个数组还是一个对象
  const newObj = obj instanceof Array ? [] : {};
  for (const key in obj) {
    // 遍历obj,并且判断是obj的属性才拷贝
    // eslint-disable-next-line
    if (obj.hasOwnProperty(key)) {
      // 判断属性值的类型，如果是对象递归调用深拷贝
      newObj[key] = typeof obj[key] === 'object' ? deepCopyObj(obj[key]) : obj[key];
    }
  }
  return newObj;
};

// storageHandles
export const storageHandles = {
  // 获取本地Local
  getLocal: (pageName: string) => {
    return JSON.parse(localStorage.getItem(pageName) as string) || {};
  },

  // 设置本地Local
  setLocal: (pageName: string, newObj: any) => {
    const obj = JSON.parse(localStorage.getItem(pageName) as string) || {};
    localStorage.setItem(pageName, JSON.stringify({ ...obj, ...newObj }));
  },
  // 获取本地Session
  getSession: (pageName: string) => {
    return JSON.parse(sessionStorage.getItem(pageName) as string) || {};
  },

  // 设置本地Session
  setSession: (pageName: string, newObj: any) => {
    const obj = JSON.parse(sessionStorage.getItem(pageName) as string) || {};
    sessionStorage.setItem(pageName, JSON.stringify({ ...obj, ...newObj }));
  },
  // 删除本地Session
  removeSession: (itemName: string) => {
    sessionStorage.removeItem(itemName);
  },
};
